import { Button, Collapse } from "reactstrap";

function TableChildTutorial({ item, index, openIndex, toggle }) {
    return (
        <>
                <div key={item.id} className="col-12">
                    <div className="payment-tutorial-card">
                        <Button
                        color="link"
                        onClick={() => toggle(index)}
                        className="payment-tutorial-toggle"
                        >
                        {item.logo && (
                            <img
                            src={item.logo}
                            alt={item.title}
                            className="payment-tutorial-logo"
                            />
                        )}
                        <span>
                            {item.title}
                        </span>
                        <i
                            className={`fa ${
                            openIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                            }`}
                        ></i>
                        </Button>

                        <Collapse isOpen={openIndex === index}>
                        <div className="payment-tutorial-steps">
                            <ul>
                                {item.steps.map((step, i) => (
                                    <li key={i}>
                                    {step}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        </Collapse>
                    </div>
                </div>
        </>
    );
}

export default TableChildTutorial;
